"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _serializr = require("serializr");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _lodash = require("lodash");
var _root_model = _interopRequireDefault(require("./root_model"));
var _word = _interopRequireDefault(require("./word"));
var _level = _interopRequireDefault(require("./level"));
var _user = _interopRequireDefault(require("./user"));
var _image = _interopRequireDefault(require("./image"));
var _page = _interopRequireDefault(require("./page"));
var _video_clip = _interopRequireDefault(require("./video_clip"));
var _word_type_basic = _interopRequireDefault(require("./word_type_basic"));
var _concept_category = _interopRequireDefault(require("./concept_category"));
var _intersecting_concept = _interopRequireDefault(require("./intersecting_concept"));
var _spacy_attribute = _interopRequireDefault(require("./spacy_attribute"));
var _sentence = _interopRequireDefault(require("./sentence"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Concept = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec3 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec4 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_word["default"]))), _dec5 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_word["default"]))), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_video_clip["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_intersecting_concept["default"]))), _dec8 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_intersecting_concept["default"]))), _dec9 = (0, _serializr.serializable)((0, _serializr.object)(_image["default"])), _dec10 = (0, _serializr.serializable)((0, _serializr.object)(_page["default"])), _dec11 = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec12 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_sentence["default"]))), _dec13 = (0, _serializr.serializable)((0, _serializr.object)(_word_type_basic["default"])), _dec14 = (0, _serializr.serializable)((0, _serializr.object)(_concept_category["default"])), _dec15 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_spacy_attribute["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function Concept() {
    var _this;
    _classCallCheck(this, Concept);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Concept, [].concat(args));
    // there is also a concept_basic.js
    _initializerDefineProperty(_this, "name", _descriptor, _this);
    _initializerDefineProperty(_this, "id", _descriptor2, _this);
    _initializerDefineProperty(_this, "rating", _descriptor3, _this);
    _initializerDefineProperty(_this, "normalizedName", _descriptor4, _this);
    _initializerDefineProperty(_this, "sentencesCount", _descriptor5, _this);
    _initializerDefineProperty(_this, "wordsCount", _descriptor6, _this);
    _initializerDefineProperty(_this, "rootWordsCount", _descriptor7, _this);
    _initializerDefineProperty(_this, "shortDescription", _descriptor8, _this);
    _initializerDefineProperty(_this, "longDescriptionMd", _descriptor9, _this);
    _initializerDefineProperty(_this, "longDescription", _descriptor10, _this);
    _initializerDefineProperty(_this, "vocab", _descriptor11, _this);
    _initializerDefineProperty(_this, "validSetup", _descriptor12, _this);
    _initializerDefineProperty(_this, "lesson", _descriptor13, _this);
    _initializerDefineProperty(_this, "abbreviation", _descriptor14, _this);
    _initializerDefineProperty(_this, "joinType", _descriptor15, _this);
    _initializerDefineProperty(_this, "automaticAssociations", _descriptor16, _this);
    _initializerDefineProperty(_this, "wordTypeId", _descriptor17, _this);
    _initializerDefineProperty(_this, "published", _descriptor18, _this);
    _initializerDefineProperty(_this, "featured", _descriptor19, _this);
    _initializerDefineProperty(_this, "pinned", _descriptor20, _this);
    _initializerDefineProperty(_this, "grammarCase", _descriptor21, _this);
    _initializerDefineProperty(_this, "grammarTense", _descriptor22, _this);
    _initializerDefineProperty(_this, "highlightInEdit", _descriptor23, _this);
    _initializerDefineProperty(_this, "levelId", _descriptor24, _this);
    _initializerDefineProperty(_this, "score", _descriptor25, _this);
    _initializerDefineProperty(_this, "showAsConcept", _descriptor26, _this);
    _initializerDefineProperty(_this, "infinitive", _descriptor27, _this);
    _initializerDefineProperty(_this, "showAsInfinitive", _descriptor28, _this);
    _initializerDefineProperty(_this, "showNameWithSource", _descriptor29, _this);
    _initializerDefineProperty(_this, "sentencesMaintainOrdering", _descriptor30, _this);
    _initializerDefineProperty(_this, "intersectingWordTypeId", _descriptor31, _this);
    _initializerDefineProperty(_this, "forumThreadId", _descriptor32, _this);
    _initializerDefineProperty(_this, "gender", _descriptor33, _this);
    _initializerDefineProperty(_this, "regex", _descriptor34, _this);
    _initializerDefineProperty(_this, "plural", _descriptor35, _this);
    _initializerDefineProperty(_this, "deckIds", _descriptor36, _this);
    _initializerDefineProperty(_this, "decksCount", _descriptor37, _this);
    _initializerDefineProperty(_this, "treeNodeConceptsCount", _descriptor38, _this);
    _initializerDefineProperty(_this, "decksAverageCompleted", _descriptor39, _this);
    _initializerDefineProperty(_this, "totalCardsCount", _descriptor40, _this);
    _initializerDefineProperty(_this, "seenCardsCount", _descriptor41, _this);
    _initializerDefineProperty(_this, "useConceptCategoryDescription", _descriptor42, _this);
    _initializerDefineProperty(_this, "showAsWordType", _descriptor43, _this);
    _initializerDefineProperty(_this, "icon", _descriptor44, _this);
    _initializerDefineProperty(_this, "conceptCategoryId", _descriptor45, _this);
    _initializerDefineProperty(_this, "displayNameLine1", _descriptor46, _this);
    _initializerDefineProperty(_this, "displayNameLine2", _descriptor47, _this);
    _initializerDefineProperty(_this, "includeConjugations", _descriptor48, _this);
    _initializerDefineProperty(_this, "showOnGenderCard", _descriptor49, _this);
    _initializerDefineProperty(_this, "showOnPluralCard", _descriptor50, _this);
    _initializerDefineProperty(_this, "showInDictionary", _descriptor51, _this);
    _initializerDefineProperty(_this, "pluralRegex", _descriptor52, _this);
    _initializerDefineProperty(_this, "spacyTense", _descriptor53, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor54, _this);
    _initializerDefineProperty(_this, "reviewed1", _descriptor55, _this);
    _initializerDefineProperty(_this, "reviewed2", _descriptor56, _this);
    _initializerDefineProperty(_this, "reviewed3", _descriptor57, _this);
    _initializerDefineProperty(_this, "vocabTriadDeckId", _descriptor58, _this);
    _initializerDefineProperty(_this, "hasAllSupplements", _descriptor59, _this);
    _initializerDefineProperty(_this, "hasAllVideoClips", _descriptor60, _this);
    _initializerDefineProperty(_this, "displaySentences", _descriptor61, _this);
    _initializerDefineProperty(_this, "commentsCount", _descriptor62, _this);
    _initializerDefineProperty(_this, "grammarNodeId", _descriptor63, _this);
    _initializerDefineProperty(_this, "youtubeUrl", _descriptor64, _this);
    _initializerDefineProperty(_this, "groupId", _descriptor65, _this);
    _initializerDefineProperty(_this, "reviewed1User", _descriptor66, _this);
    _initializerDefineProperty(_this, "reviewed2User", _descriptor67, _this);
    _initializerDefineProperty(_this, "reviewed3User", _descriptor68, _this);
    _initializerDefineProperty(_this, "words", _descriptor69, _this);
    _initializerDefineProperty(_this, "intersectingWords", _descriptor70, _this);
    _initializerDefineProperty(_this, "videoClip", _descriptor71, _this);
    _initializerDefineProperty(_this, "intersectingConcepts", _descriptor72, _this);
    _initializerDefineProperty(_this, "unionConcepts", _descriptor73, _this);
    _initializerDefineProperty(_this, "image", _descriptor74, _this);
    _initializerDefineProperty(_this, "page", _descriptor75, _this);
    _initializerDefineProperty(_this, "level", _descriptor76, _this);
    _initializerDefineProperty(_this, "sentences", _descriptor77, _this);
    _initializerDefineProperty(_this, "wordType", _descriptor78, _this);
    _initializerDefineProperty(_this, "conceptCategory", _descriptor79, _this);
    _initializerDefineProperty(_this, "spacyAttributes", _descriptor80, _this);
    return _this;
  }
  _inherits(Concept, _RootModel);
  return _createClass(Concept, [{
    key: "displayNameLine1WithCase",
    get: function get() {
      if ((0, _utils.isPresent)(this.displayNameLine1) && this.languageId === 'DE') {
        return (0, _lodash.compact)([this.displayNameLine1, this.caseName]).join(', ');
      } else if ((0, _utils.isPresent)(this.displayNameLine1)) {
        return this.displayNameLine1;
      }
      return this.name;
    }
  }, {
    key: "caseName",
    get: function get() {
      var _this2 = this;
      var myCase = _constants.Constants.CASES.find(function (item) {
        return item.abbreviation === _this2.grammarCase;
      });
      if (myCase && myCase.name === 'None' && this.languageId === 'DE') {
        return 'No Case';
      }
      if (myCase) {
        return "".concat(myCase.name, " Case");
      }
      return null;
    }
  }, {
    key: "requiresCase",
    get: function get() {
      return this.hasWordType && this.wordType.requiresCase;
    }
  }, {
    key: "noun",
    get: function get() {
      return this.hasWordType && this.wordType.abbreviation === 'noun';
    }
  }, {
    key: "verb",
    get: function get() {
      return this.hasWordType && this.wordType.abbreviation === 'vrb';
    }
  }, {
    key: "isDative",
    get: function get() {
      return this.grammarCase === 'Dt' || this.grammarCase === '2w-Dt';
    }
  }, {
    key: "isAccusative",
    get: function get() {
      return this.grammarCase === 'Ak' || this.grammarCase === '2w-Ak';
    }
  }, {
    key: "isNominative",
    get: function get() {
      return this.grammarCase === 'Nm';
    }
  }, {
    key: "isGenitive",
    get: function get() {
      return this.grammarCase === 'Gn';
    }
  }, {
    key: "imageUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.image) ? this.image.url : null;
    }
  }, {
    key: "levelAbbreviation",
    get: function get() {
      return (0, _utils.isPresent)(this.level) ? this.level.abbreviation : null;
    }
  }, {
    key: "intersectingWordIds",
    get: function get() {
      return (0, _utils.isPresent)(this.intersectingWords) ? this.intersectingWords.map(function (item) {
        return item.id;
      }) : {};
    }
  }, {
    key: "intersectingConceptIds",
    get: function get() {
      return (0, _utils.isPresent)(this.intersectingConcepts) ? this.intersectingConcepts.map(function (item) {
        return item.id;
      }) : {};
    }
  }, {
    key: "unionConceptIds",
    get: function get() {
      return (0, _utils.isPresent)(this.unionConcepts) ? this.unionConcepts.map(function (item) {
        return item.id;
      }) : {};
    }
  }, {
    key: "hasVideoClip",
    get: function get() {
      return (0, _utils.isPresent)(this.videoClip);
    }
  }, {
    key: "hasWordType",
    get: function get() {
      return (0, _utils.isPresent)(this.wordType) && (0, _utils.isPresent)(this.wordType.id);
    }
  }, {
    key: "mappedIntersectingWords",
    get: function get() {
      return this.intersectingWords.map(function (item) {
        return {
          id: item.id,
          name: item.targetWithWordTypeParentInfinitiveAndSource
        };
      });
    }
  }, {
    key: "mappedIntersectingConcepts",
    get: function get() {
      return this.intersectingConcepts.map(function (item) {
        return {
          id: item.id,
          name: item.name
        };
      });
    }
  }, {
    key: "mappedUnionConcepts",
    get: function get() {
      return this.unionConcepts.map(function (item) {
        return {
          id: item.id,
          name: item.name
        };
      });
    }
  }, {
    key: "nameAndLevel",
    get: function get() {
      return "".concat(this.name, " (").concat(this.levelAbbreviation, ")");
    }
  }, {
    key: "nameAndLevelAndSentencesCount",
    get: function get() {
      return "".concat(this.nameAndLevel, " - ").concat(this.sentencesCount, " sentences");
    }
  }, {
    key: "nameAndLevelAndSentencesAndDecksCount",
    get: function get() {
      return "".concat(this.nameAndLevel, " - ").concat(this.decksCount, " decks - ").concat(this.sentencesCount, " sentences");
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "rating", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "normalizedName", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sentencesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "wordsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "rootWordsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "shortDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "longDescriptionMd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "longDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "vocab", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "validSetup", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "lesson", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "abbreviation", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "joinType", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "automaticAssociations", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "wordTypeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "published", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "featured", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "pinned", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "grammarCase", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "grammarTense", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "highlightInEdit", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "levelId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "score", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "showAsConcept", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "infinitive", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "showAsInfinitive", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "showNameWithSource", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "sentencesMaintainOrdering", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "intersectingWordTypeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "forumThreadId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "gender", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "regex", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "plural", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "deckIds", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "decksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "treeNodeConceptsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "decksAverageCompleted", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "totalCardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "seenCardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "useConceptCategoryDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "showAsWordType", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "icon", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "conceptCategoryId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "displayNameLine1", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "displayNameLine2", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "includeConjugations", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "showOnGenderCard", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "showOnPluralCard", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "showInDictionary", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "pluralRegex", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "spacyTense", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "reviewed1", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "reviewed2", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "reviewed3", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "vocabTriadDeckId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "hasAllSupplements", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "hasAllVideoClips", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "displaySentences", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "commentsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "grammarNodeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "youtubeUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "groupId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "reviewed1User", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "reviewed2User", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "reviewed3User", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "words", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "intersectingWords", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "videoClip", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "intersectingConcepts", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "unionConcepts", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "image", [_mobx.observable, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "page", [_mobx.observable, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "level", [_mobx.observable, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "sentences", [_mobx.observable, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "wordType", [_mobx.observable, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "conceptCategory", [_mobx.observable, _dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "spacyAttributes", [_mobx.observable, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "displayNameLine1WithCase", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayNameLine1WithCase"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "caseName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "caseName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "requiresCase", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "requiresCase"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "noun"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "verb", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "verb"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDative", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDative"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAccusative", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAccusative"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNominative", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNominative"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGenitive", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGenitive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "levelAbbreviation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "levelAbbreviation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "intersectingWordIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "intersectingWordIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "intersectingConceptIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "intersectingConceptIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unionConceptIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "unionConceptIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasWordType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasWordType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mappedIntersectingWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mappedIntersectingWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mappedIntersectingConcepts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mappedIntersectingConcepts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mappedUnionConcepts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mappedUnionConcepts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nameAndLevel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nameAndLevel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nameAndLevelAndSentencesCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nameAndLevelAndSentencesCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nameAndLevelAndSentencesAndDecksCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nameAndLevelAndSentencesAndDecksCount"), _class.prototype), _class);
var _default = exports["default"] = Concept;